import { Box, Tooltip, Typography } from '@material-ui/core'
import { HelpOutline } from '@material-ui/icons'
import React from 'react'
import IOSSwitch from '../../IOSSwitch'
import { SbFolder } from './type'

export interface SbSettingToggleProps {
  onUpdate: (
    property: keyof SbFolder,
    newValue: number | string | boolean
  ) => void
  field: keyof SbFolder
  label: string
  isChecked: boolean
  tooltip: string
  disabled?: boolean
}

export default function SbSettingToggle({
  onUpdate,
  field,
  label,
  isChecked,
  tooltip,
  disabled = false,
}: SbSettingToggleProps) {
  return (
    <Box display="flex" alignItems="center">
      <IOSSwitch
        checked={isChecked}
        disabled={disabled}
        onChange={() => onUpdate(field, !isChecked)}
        name={`sb-folder-${field}`}
      />

      <Typography variant="button" component="span" style={{ marginLeft: 10 }}>
        {label}
      </Typography>

      <Box ml={1.5} pt={0.7}>
        <Tooltip title={tooltip}>
          <HelpOutline color="action" style={{ fontSize: '1.1rem' }} />
        </Tooltip>
      </Box>
    </Box>
  )
}
